export default __webpack_public_path__ + "b566c498e2c81a8075ec132c2f549686.png";